// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__HJPj6","left":"InfoRow_left__1lYYi"};